import React from 'react';
import './FaceBox.scss';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import { isTranscoder1, isOriginTranscoder1 }
    from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FaceView from 'Flow2/components/Ai/Faces/FaceView/FaceView.js';
import { faSmile, faBars } from '@fortawesome/free-solid-svg-icons';
import FacePreview from "Flow2/components/Ai/Faces/FacePreview/FacePreview";

class FaceBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    initData = () => {
        this.props.listCollections();
        this.props.listSubjects();
    }

    onFaceBtnClick = () => {
        const { faceSubjects } = this.props.faceObjects;
        this.props.updateFaceObjects({
            faceSubjects: { ...faceSubjects, showOverlay: true },
            showFaceBox: true
        });
        this.setState({ showBox: true });
    }

    componentDidUpdate(prev) {
        const { faceRecognize } = this.props.faceObjects;
        const { clipUrl, clipHeight, clipWidth } = faceRecognize;
        if (!prev.faceObjects.faceRecognize.showOverlay && faceRecognize.showOverlay) {
            this.setState({ showPreviewBox: true, clipUrl, clipHeight, clipWidth });
        }
    }

    componentDidMount() {
        this.initData();
    }


    showFaceButton = () => {
        if (isTranscoder1() || isOriginTranscoder1())
            return (
                <div className="FaceButton">
                    <div onClick={this.onFaceBtnClick}>
                        <div className="FaceIconBtnTop"><FontAwesomeIcon icon={faSmile} /></div>
                        <div className="FaceIconBtn"><FontAwesomeIcon icon={faBars} /></div>
                    </div>
                    {this.state.showBox
                        ? <FaceView titleIntl="data.face.title" data={this.props.data}
                            mainObj={this.props.faceObjects} mainObjName="faceObjects" subObjName="faceSubjects"
                            updatePopUpObjects={this.props.updateFaceObjects} />
                        : <div />}
                    {this.state.showPreviewBox && (
                        <FacePreview titleIntl="data.crop.newclip.question"
                            previewSrc={this.state.clipUrl} previewWidth={this.state.clipWidth}
                            previewHeight={this.state.clipHeight}
                            clip={this.props.clip}
                            mainObj={this.props.faceObjects} mainObjName="faceObjects" subObjName="faceRecognize"
                            updatePopUpObjects={this.props.updateFaceObjects} />
                    )}
                </div>)
    }

    render() {
        return (
            <div className="FaceBox">
                {this.showFaceButton()}
            </div>)
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
})

const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
    listSubjects: () => dispatch(actions.listSubjects()),
    listCollections: () => dispatch(actions.listCollections())
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FaceBox));